<template>
  <v-app :style="{ backgroundColor: backgroundColor }">
    <component v-bind:is="layout"></component>

    <alert-component></alert-component>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BlankLayout from './layouts/Blank.vue';
import AppLayout from './layouts/App.vue';
import AlertComponent from './components/global/AlertComponent.vue';

export default {
  name: 'App',

  components: {
    BlankLayout,
    AppLayout,
    AlertComponent,
  },

  watch: {
    me(val) {
      if (val) {
        window.addEventListener('focus', this.refreshUserSession);
      } else {
        window.removeEventListener('focus', this.refreshUserSession);
      }
    },
  },

  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'getPermissions', 'getTokensRequest']),
    ...mapGetters('auth', { me: 'getUser', refreshToken: 'getRefreshToken', session: 'getSession' }),
    ...mapGetters({
      backgroundColor: 'page/getBackgroundColor',
    }),

    layout() {
      return `${this.$route.meta.layout || 'app'}-layout`;
    },
  },

  methods: {
    ...mapActions({
      logout: 'auth/logout',
      fetchMe: 'auth/fetchMe',
      fetchLanguages: 'languages/fetchAll',
      fetchCurrencies: 'currencies/fetchAll',
      fetchDialCodes: 'dialCodes/fetchAllDialCodes',
      refreshSession: 'auth/refreshSession',
    }),

    refreshUserSession() {
      if (new Date(this.session.accessExpirationAt).getTime() > Date.now() + 1800000) {
        return;
      }
      this.refreshSession({ refreshToken: this.refreshToken });
    },

    async _initApp() {
      this.fetchLanguages();
      this.fetchCurrencies();
      this.fetchDialCodes();

      if (this.getTokensRequest) {
        await this.getTokensRequest;
      }

      if (this.isAuthenticated) {
        this.fetchMe();
      } else {
        this.$router.push({ name: 'logout' });
      }
    },
  },

  created() {
    this._initApp();
  },
};
</script>

<style lang="scss">
.theme--light.v-tabs > .v-tabs-bar {
  background-color: transparent !important;
  margin-bottom: 16px;
}

.theme--light.v-tabs-items {
  background-color: transparent !important;
}

.v-application {
  .header .v-input,
  .v-navigation-drawer {
    background-color: #ffffff;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
      0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  }

  .header fieldset {
    border: none !important;
  }

  .action-button {
    box-shadow: none;
    color: #717171;

    &:not(:last-child) {
      margin-right: 8px;
    }
  }

  .action-button--error {
    color: #ff5256;
  }

  .flex-grow-7 {
    flex-grow: 55 !important;
  }

  .flex-grow-3 {
    flex-grow: 3 !important;
  }
}

// Make the background of outlined text inputs / selects etc.
// white -> needed when the bg color is changed
// (for example: to green, to indicate a first time customer)
.v-text-field--outlined > .v-input__control > .v-input__slot {
  background-color: white !important;
}

// the same as above but for buttons
.v-btn--outlined {
  background-color: white !important;
}

.graph-height {
  max-height: 500px;
}

.text-normal {
  text-transform: none;
}

.color-white {
  color: #ffffff !important;
}

.color-black {
  color: #000000;
}

.color-primary {
  color: #673ab7;
}

.color-red {
  color: #f44336;
}
.bg-white {
  background: white;
}

.link--white {
  color: currentColor !important;
  text-decoration: underline !important;
}

.gap-4 {
  gap: 1rem;
}

.w-100 {
  width: 100%;
}

.w-50 {
  width: 50%;
}

.h-100 {
  height: 100%;
}

.gap-1 {
  gap: 0.25rem;
}

.flex-8 {
  flex: 0 0 2rem;
}

.w-fit {
  width: fit-content;
}

.w-initial {
  width: initial !important;
}

.relative {
  position: relative;
}

iframe {
  border: none;
  display: block;
}
</style>
